import { connect } from 'react-redux'
import Leagues from '../components/leagues'

const mapStateToProps = state => ({...state.leagues})

const mapDispatchToProps = dispatch => ({
  onTriggerPast: payload => dispatch({type: 'LEAGUES.TRIGGER_PAST', payload}),
  setPage: payload => dispatch({type: 'LEAGUES.PAGE', payload}),
  setPerPage: payload => dispatch({type: 'LEAGUES.PER_PAGE', payload}),
  onSearch: payload => dispatch({type: 'LEAGUES.SEARCH', payload}),
  onCreate: payload => dispatch({type: 'LEAGUES.CREATE', payload}),
  onUpdate: payload => dispatch({type: 'LEAGUES.UPDATE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(Leagues)
